module.exports = __webpack_public_path__ + "img/9788963576053.6da4fd5c.jpg";